import RemoveBossModeModal from './RemoveBossModeModal.component';

export default RemoveBossModeModal;